module.exports = __webpack_public_path__ + "static/media/BTC-GRC.594578c7.jpg";